import axios from 'axios';
import { getItem } from '../utils';

const token = getItem('clientToken');
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.headers.common = {'Authorization': `bearer ${token}`}
// axios.defaults.headers.common = {'Content-Type': `application/json`}
export default axios;